export default "__VITE_PUBLIC_ASSET__5dd59f3b__"